import { CategorizedDocumentsEntry } from "@/components/documents/CategorizedDocumentsEntry"

import type { CommonDocument } from "./context/DocumentsProvider"

interface Props {
  title: string
  documents: CommonDocument[]
}

export function CategorizedDocumentsList({ title, documents }: Props) {
  return (
    <div>
      <h1 className="mt-1 text-sm font-bold">{title}</h1>
      {documents.map((doc) => (
        <CategorizedDocumentsEntry key={doc.uuid} doc={doc} />
      ))}
    </div>
  )
}
